import ReactPixel from 'react-facebook-pixel';

// Inicializar el Pixel de Meta solo en producción
export const initMetaPixel = () => {
  if (window.location.hostname === "localhost") {
    console.log("Pixel de Meta DESACTIVADO en localhost");
    return;
  }

  const pixelId = '3548485838787487';
  ReactPixel.init(pixelId);
  ReactPixel.pageView();
  console.log("Pixel de Meta ACTIVADO");
};

// Función para rastrear eventos personalizados
export const trackMetaEvent = (eventName, data = {}) => {
  if (window.location.hostname === "localhost") {
    console.log(`Evento '${eventName}' NO enviado en localhost`);
    return;
  }

  ReactPixel.track(eventName, data);
  console.log(`Evento '${eventName}' enviado con datos:`, data);
};
